/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class FilterValue {
    getFixupPrototypeFunction() { return FilterValue.fixupPrototype; }

    static newInstance(model: Partial<FilterValue>): FilterValue {
        let obj = Object.assign(new FilterValue(), model);
        FilterValue.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<FilterValue>): FilterValue {
        if (!model) return null;
        return FilterValue.newInstance(<FilterValue> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: FilterValue) {
        if (!obj) return;

        models.FilterValue.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: FilterValue): boolean {
        Object.setPrototypeOf(obj, FilterValue.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.cloud_account) {
            for (let val of this.cloud_account) {
                models.RangeValue.fixupPrototype(val);
            }
        }
    }

    /**
     * Reservation SKU Details
     */
    reservation_sku: Array<string>;

    /**
     * Available payment option
     */
    payment_option: Array<string>;

    /**
     * Region available
     */
    region: Array<string>;

    /**
     * Reservation Type
     */
    reservation_type: Array<string>;

    /**
     * Cloud Account Details
     */
    cloud_account: Array<models.RangeValue>;

    /**
     * Tenant name
     */
    tenant: Array<string>;

}
